import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useResetWorkspaceModuleMutation } from '@platform/state/api';
import { useFailToast } from '../system/useFailToast';
import type { IModuleRowState } from './IModuleRowState';

/**
 * «Скинути» рядка «Встановлених модулів» (рішення 2 етапу 9; прототип v4 cmRows.onReset — після підтвердження): одна дія сервера з аудитом
 * POST /workspaces/{ws}/modules/{key}/reset — модуль (головний рядок): назва й доступність типові, перевизначення всіх типів модуля
 * скидаються; дочірня таблиця — `?recordType=` (лише її перевизначення). Записи й додані поля зберігаються (як у прототипі).
 */
export function useModuleReset(ws: string): (s: IModuleRowState) => void {
  const { t } = useTranslation();
  const fail = useFailToast();
  const [reset] = useResetWorkspaceModuleMutation();
  return useCallback((s: IModuleRowState) => {
    if (!window.confirm(t('sysCust.modules.resetConfirm', { name: s.name }))) return;
    reset({ ws, moduleKey: s.row.def.module.key, recordType: s.row.rt.main ? undefined : s.row.rt.key }).unwrap().catch(fail);
  }, [t, ws, reset, fail]);
}
